/*
  Canvas by Numbers - sale countdown (no app).
  Markup comes from snippets/cbn-countdown.liquid:
    [data-cbn-cd data-end="<unix seconds>" (data-daily)]
  - product box: .cbn-cd__unit[data-unit=d|h|m|s] > b
  - announcement bar: [data-cbn-cd-text]
  Elements start hidden and are shown only while there is time left, so an
  expired countdown never flashes, even on a cached page.
*/
(() => {
    if (window.cbnCountdownInit) return
    window.cbnCountdownInit = true

    const DAY = 86400
    const pad = (n) => String(n).padStart(2, '0')

    const tick = () => {
        const now = Math.floor(Date.now() / 1000)
        document.querySelectorAll('[data-cbn-cd]').forEach((el) => {
            let end = Number(el.getAttribute('data-end')) || 0
            // Daily countdown on a page cached before midnight: roll to the next midnight
            if (el.hasAttribute('data-daily')) while (end && end <= now) end += DAY
            const left = end - now
            if (left <= 0) { el.hidden = true; return }

            const d = Math.floor(left / DAY)
            const h = Math.floor((left % DAY) / 3600)
            const m = Math.floor((left % 3600) / 60)
            const s = left % 60

            const text = el.querySelector('[data-cbn-cd-text]')
            if (text) {
                text.textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s)
            } else {
                const set = (unit, value, hide) => {
                    const box = el.querySelector('[data-unit="' + unit + '"]')
                    if (!box) return
                    box.hidden = !!hide
                    const b = box.querySelector('b')
                    if (b && b.textContent !== value) b.textContent = value
                }
                set('d', pad(d), d === 0)
                set('h', pad(h))
                set('m', pad(m))
                set('s', pad(s))
            }
            el.hidden = false
        })
    }

    tick()
    setInterval(tick, 1000)
})()
